import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as fromRoot from '../reducers';
import * as actions from '../actions/authentication';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-forgot-password',
  template: `<div class="row justify-content-center" style="padding-top:20px;">
      <div *ngIf="!resetRequested" class="col-md-4">
          <div class="card">
              <div class="card-header">
                  <h6 class="text-center">Reset Password</h6>
              </div>
              <div class="card-body">
                  <form (ngSubmit)="resetPassword()">
                      <div class="form-group" 
                           [ngClass]="{'has-error':!resetForm.controls['username'].valid && resetForm.controls['username'].touched}">
                          <input class="form-control" placeholder="User Name" [formControl]="resetForm.controls['username']">
                      </div>
                      <button class="btn btn-sm btn-outline-primary btn-block" [disabled]="waiting$ | async">
                        <span *ngIf="waiting$ | async">Resetting Password</span>
                        <span *ngIf="!(waiting$ | async)">Reset Password</span>
                      </button>
                  </form>
              </div>
          </div>
      </div>
      <div *ngIf="resetRequested" class="col-md-6 text-center">
          Your password reset request has been processed.  
        An email containing your temporary password will be sent to the email address on the account.
          <br/>
          <a routerLink="/login">Back to Login</a>
      </div>
  </div>
  `
})
export class ForgotPasswordPageComponent implements OnInit {

  public resetForm: FormGroup;
  public resetRequested = false;
  public waiting$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>,
              private fb: FormBuilder) {
    this.resetForm = this.fb.group({
      'username': [null, Validators.required]
    });
    this.waiting$ = this.store.select(fromRoot.getAuthWorking);
  }

  public resetPassword() {
    if (!this.resetForm.valid) {
      this.resetForm.controls['username'].markAsTouched();
      return;
    }
    const username: string = this.resetForm.controls['username'].value;
    this.store.dispatch(new actions.ResetPasswordAction(username));
    this.resetRequested = true;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/forgot-password.ts